import { useState, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useTheme, BottomNavigation, BottomNavigationAction, Container, Box } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'; // Wallet icon
import DescriptionIcon from '@mui/icons-material/Description';
import MenuIcon from '@mui/icons-material/Menu'; // Menu icon
import AllInboxIcon from '@mui/icons-material/AllInbox';
import URIs from "../utils/uri";

const DefaultLayout = () => {
    const theme = useTheme();
    const location = useLocation();
    const [value, setValue] = useState(0); // State to handle active navigation item
    const navigate = useNavigate();

    const routeToValueMap = {
        [URIs.HOME]: 0,
        [URIs.GOLD_BOX]: 1,
        [URIs.TRANSACTOINS]: 2,
        [URIs.WALLET]: 3,
        [URIs.MENU]: 4,
    };

    useEffect(() => {
        // Update value based on current route
        const newValue = routeToValueMap[location.pathname] ?? 0; // Default to 0 if no match
        setValue(newValue);
    }, [location.pathname]);


    const handleChange = (event, newValue) => {
        setValue(newValue)
        switch (newValue) {
            case 0:
                navigate(URIs.HOME);
                break;
            case 1:
                navigate(URIs.GOLD_BOX);
                break;
            case 2:
                navigate(URIs.TRANSACTOINS);
                break;
            case 3:
                navigate(URIs.WALLET);
                break;
            case 4:
                navigate(URIs.MENU);
                break;
            default:
                navigate(URIs.HOME);
                break;
        }
    }

    return (
        <Box
            sx={{
                minHeight: '100vh',
                background: theme.palette.background.default,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                position: 'relative',
            }}
        >
            <Container
                maxWidth="sm"
                disableGutters
                sx={{
                    flex: 1,
                    width: '100%',
                }}
            >
                <Outlet />
            </Container>

            <BottomNavigation
                value={value}
                onChange={handleChange}
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    left: '50%',
                    transform: 'translateX(-50%)', // Center it horizontally
                    width: '100%',
                    height: "60px",
                    maxWidth: '600px',
                    overflow: 'visible',
                    paddingBottom: `calc(env(safe-area-inset-bottom) + 10px)`,
                    paddingX: "10px",
                    backgroundColor: theme.palette.background.default,
                    zIndex: 1000,
                }}
            >
                <BottomNavigationAction
                    label="خانه"
                    showLabel={true}
                    icon={<DashboardIcon />}
                    sx={{
                        flex: '0 1 60px',
                        color: value === 0 ? theme.palette.primary.main : theme.palette.text.default,
                        padding: "8px",
                        borderRadius: '14px 14px 0 0',
                        backgroundColor: value === 0 ? theme.palette.background.dark : 'transparent',
                    }}
                />
                <BottomNavigationAction
                    label="صندوقچه"
                    showLabel={true}
                    icon={<AllInboxIcon />}
                    sx={{
                        flex: '0 1 60px',
                        color: value === 1 ? theme.palette.primary.main : theme.palette.text.default,
                        padding: "8px",
                        borderRadius: '14px 14px 0 0',
                        backgroundColor: value === 1 ? theme.palette.background.dark : 'transparent',
                    }}
                />
                <BottomNavigationAction
                    label="تاریخچه"
                    showLabel={true}
                    icon={<DescriptionIcon />}
                    sx={{
                        flex: '0 1 60px',
                        color: value === 2 ? theme.palette.primary.main : theme.palette.text.default,
                        padding: "8px",
                        borderRadius: '14px 14px 0 0',
                        backgroundColor: value === 2 ? theme.palette.background.dark : 'transparent',
                    }}
                />
                <BottomNavigationAction
                    label="کیف پول"
                    showLabel={true}
                    icon={<AccountBalanceWalletIcon />}
                    sx={{
                        flex: '0 1 60px',
                        color: value === 3 ? theme.palette.primary.main : theme.palette.text.default,
                        padding: "8px",
                        borderRadius: '14px 14px 0 0',
                        backgroundColor: value === 3 ? theme.palette.background.dark : 'transparent'
                    }}
                />
                <BottomNavigationAction
                    label="منو"
                    showLabel={true}
                    icon={<MenuIcon />}
                    sx={{
                        flex: '0 1 60px',
                        color: value === 4 ? theme.palette.primary.main : theme.palette.text.default,
                        padding: "8px",
                        borderRadius: '14px 14px 0 0',
                        backgroundColor: value === 4 ? theme.palette.background.dark : 'transparent',
                    }}
                />
            </BottomNavigation>
        </Box>
    );
};

export default DefaultLayout;
